export default __webpack_public_path__ + "static/media/service-24.7e309ba7.png";